import { addDays } from '@hp/domain';

export const PRESETS = ['seven', 'thirty', 'ninety', 'ytd', 'lastYear', 'custom'] as const;
export type Preset = (typeof PRESETS)[number];
export const COMPARE = ['previous', 'year', 'none'] as const;
export type Compare = (typeof COMPARE)[number];
export const VIEWS = ['manager', 'marketing'] as const;
export type View = (typeof VIEWS)[number];

export interface DashboardFilter {
  preset: Preset;
  from: string;
  to: string;
  compare: Compare;
  channels: string[];
  projects: string[];
  campaigns: string[];
}

export function presetRange(preset: Preset, today: string): { from: string; to: string } {
  const year = today.slice(0, 4);
  switch (preset) {
    case 'seven':
      return { from: addDays(today, -6), to: today };
    case 'thirty':
      return { from: addDays(today, -29), to: today };
    case 'ninety':
      return { from: addDays(today, -89), to: today };
    case 'ytd':
      return { from: `${year}-01-01`, to: today };
    case 'lastYear': {
      const y = Number(year) - 1;
      return { from: `${y}-01-01`, to: `${y}-12-31` };
    }
    case 'custom':
      return { from: addDays(today, -29), to: today };
  }
}

export function defaultFilter(today: string): DashboardFilter {
  return {
    preset: 'thirty',
    ...presetRange('thirty', today),
    compare: 'previous',
    channels: [],
    projects: [],
    campaigns: [],
  };
}

export function isFilterActive(f: DashboardFilter, today: string): boolean {
  const d = defaultFilter(today);
  return (
    f.preset !== d.preset ||
    f.from !== d.from ||
    f.to !== d.to ||
    f.compare !== d.compare ||
    f.channels.length > 0 ||
    f.projects.length > 0 ||
    f.campaigns.length > 0
  );
}
